<template>
  <div class="grey lighten-4 pa-4" style="min-height: 100vh;">
    <v-container>
      <v-card>
        <v-toolbar flat color="teal darken-1" dark>
          <v-toolbar-title>
            <v-icon left>mdi-forum</v-icon>
            Administración del Foro
          </v-toolbar-title>
        </v-toolbar>

        <!-- PC: Tabs con flechas -->
        <v-tabs v-if="$vuetify.breakpoint.mdAndUp" v-model="tab" show-arrows
          background-color="teal lighten-5">
          <v-tab v-for="item in sections" :key="item.key" :href="'#' + item.key">
            <v-icon left small>{{ item.icon }}</v-icon>
            {{ item.text }}
          </v-tab>
        </v-tabs>

        <!-- Mobile: Select -->
        <div v-else class="pa-3">
          <v-select v-model="tab" :items="sections" item-text="text" item-value="key"
            outlined dense hide-details prepend-inner-icon="mdi-menu">
          </v-select>
        </div>

        <v-tabs-items v-model="tab">
          <!-- TAB CATEGORÍAS -->
          <v-tab-item value="categorias">
            <forum-categoria-admin></forum-categoria-admin>
          </v-tab-item>

          <!-- TAB POSTS -->
          <v-tab-item value="posts">
            <forum-post-admin></forum-post-admin>
          </v-tab-item>

          <!-- TAB CABECERA -->
          <v-tab-item value="cabecera">
            <forum-blog-settings-admin></forum-blog-settings-admin>
          </v-tab-item>

          <!-- TAB AUTORES -->
          <v-tab-item value="autores">
            <forum-author-admin></forum-author-admin>
          </v-tab-item>

          <!-- TAB ACTIVIDAD -->
          <v-tab-item value="actividad">
            <forum-activity-admin></forum-activity-admin>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import ForumCategoriaAdmin from '@/components/forum/ForumCategoriaAdmin.vue';
import ForumPostAdmin from '@/components/forum/ForumPostAdmin.vue';
import ForumBlogSettingsAdmin from '@/components/forum/ForumBlogSettingsAdmin.vue';
import ForumAuthorAdmin from '@/components/forum/ForumAuthorAdmin.vue';
import ForumActivityAdmin from '@/components/forum/ForumActivityAdmin.vue';

export default {
  name: 'ForumAdminV',
  components: {
    ForumCategoriaAdmin,
    ForumPostAdmin,
    ForumBlogSettingsAdmin,
    ForumAuthorAdmin,
    ForumActivityAdmin
  },
  data() {
    return {
      tab: 'categorias',
      sections: [
        { key: 'categorias', text: 'Categorías', icon: 'mdi-folder' },
        { key: 'posts', text: 'Posts', icon: 'mdi-post' },
        { key: 'cabecera', text: 'Cabecera', icon: 'mdi-page-layout-header' },
        { key: 'autores', text: 'Autores', icon: 'mdi-account-edit' },
        { key: 'actividad', text: 'Actividad', icon: 'mdi-chart-bar' },
      ]
    };
  }
};
</script>
